<template>
	<!-- 游客信息插件 -->
	<div>
		<div class="ykbox ddcheckitem">
			<div class="yktitle" style="padding-top: 0;">
				<div class="title">入住信息</div>
				<div class="rightnum">
					共 {{yknum}} 间房(每间最多住2人)
				</div>
			</div>
			<div class="yklist">
				<!-- <div class="ykitem" > -->
				<van-form validate-first @failed="onFailed">
					<van-field label="联系手机" v-model="tel" type="tel" placeholder="用于接收通知短信"
						:rules="[{ required: true, message: '请填写手机号' }]" clearable/>
					<van-field v-for="(item,index) in ykListData" :key="index"
					 right-icon="question-o" :label="'房间'+(index+1)" v-model="item.contacts"
					  placeholder="每间只填1人,姓名不可重复" clearable @click-right-icon="show=true"
						:rules="[{ required: true, message: '请填写住客姓名' }]" 
						/>
				<!-- 	<van-field :label="'房间2'" placeholder="每间只填1人,姓名不可重复"
						:rules="[{ required: true, message: '请填写住客姓名' }]" clearable/>
					<van-field :label="'房间2'" placeholder="每间只填1人,姓名不可重复"
						:rules="[{ required: true, message: '请填写住客姓名' }]" clearable/>
					<van-field :label="'房间2'" placeholder="每间只填1人,姓名不可重复"
						:rules="[{ required: true, message: '请填写住客姓名' }]" clearable/> -->

				</van-form>
				<!-- </div> -->
			</div>
		</div>
		<van-popup class="bottompopup" v-model="show" position="bottom" :style="{ height: '48%' }">
			<div class="toptitle">
				<div class="title">
					<span>住客姓名填写说明</span>
				</div>
				<div class="clode" @click="show=false">
					<van-icon name="cross" />
				</div>
			</div>
			<div class="p-conten">
				<p><span class="dian">.</span><span class="nr">住客姓名需要与实际住客证件号上的姓名保持一直</span></p>
				<p><span class="dian">.</span><span class="nr">中文姓名请填写汉字</span></p>
				<p><span class="dian">.</span><span class="nr">英文姓名格式为Surname(姓)/Given name(名)Middle name(中间名),姓在前，姓和名之间用"/"隔开,如
						有中间名则空一格紧随之后,如Jenson Green Lewis,填写Jenson/Green Lewis</span></p>
				<p><span class="dian">.</span><span class="nr">预定多个房间时，请填写多个不同的住客姓名</span></p>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant'
	export default {
		props: {
			isOne: {
				type: Boolean,
				default: false
			},
			goodsnum: {
				type: Number,
				default: 1
			},
			totalnum: {
				type: Number,
				default: 0
			},
		},
		data() {
			return {
				show: false,
				isHotel: true,
				yknum: this.goodsnum,
				selectid: 0,
				titlename: '新增游客', 
				selectnum: 0, //已填写数量
				ykListData: [],
				tel:'',
				ykpopupshow: false
			}
		},
		created() {
			this.defuaultListNum()
		},
		methods: {
			// 添加游客信息
			addYkxx() {
				let that = this
				let msg = "";
				if (that.ykxx.namenew == '') {
					msg = "请填写姓名";
				} else if (that.ykxx.telnew == '') {
					msg = "请填写手机号";
				} else if (that.ykxx.idcardnew == '') {
					msg = "请填写证件号";
				}
				if (msg != "") {
					Toast({
						message: msg
					});
					return;
				} else {
					let idata = {
						contacts: that.ykxx.namenew,
						telephone: that.ykxx.telnew,
						IDCard: that.ykxx.idcardnew
					}
					that.ykListData.splice(that.selectid, 1, idata)
					this.$emit('onSubmit', that.ykListData)
					that.ykpopupshow = false
				}
			},
			// 打开添加游客信/息
			openYkpopup(item, i) {
				let that = this
				let tt = item
				that.ykpopupshow = true;
				that.ykxx.namenew = tt.contacts;
				that.ykxx.telnew = tt.telephone;
				that.ykxx.idcardnew = tt.IDCard;
				if (item.contacts != "") {
					that.titlename = '编辑游客'
				}
				that.selectid = i;
			},
			onChangeNum(v) {
				this.$emit('onChangeNum', v)
			},
			// 添加游客
			addYk(isadd) {
				let that = this
				// 只需填写一位游客信息
				if (that.isOne) {
					return;
				}
				if (isadd) {
					let item = {
						contacts: '',
						telephone: '',
						IDCard: ''
					}
					that.ykListData.unshift(item)
				} else {
					that.ykListData.splice(0, 1)
				}
				this.$emit('onSubmit', that.ykListData)
			},
			// 删除游客
			cutYk(i) {
				let that = this
				let item = {
					contacts: '',
					telephone: '',
					IDCard: ''
				}
				that.ykListData.splice(i, 1, item)
			},
			closePopup() {
				this.ykpopupshow = false
			},
			// 初始化游客数量
			defuaultListNum() {
				let that = this
				for (var i = 1; i <= that.yknum; i++) {
					let item = {
						contacts: ''
					}
					that.ykListData.unshift(item)
				}
			}
		}
	}
</script>

<style lang="less">
	/deep/ .van-popup--bottom {
		margin-bottom: 0 !important;
	}

	.bottompopup {
		.toptitle {
			padding: 10px 5px;
			display: flex;
			justify-content: space-between;

			.title {
				flex: 1;
				text-align: center;
			}

			.clode {
				width: 20px;
			}
		}

		.p-conten {
			padding: 15px;

			p {
				padding: 5px 0;
				line-height: 22px;
				display: flex;
				.dian{
					width: 20px;
					font-weight: 800; 
					display: block; 
				}
				.nr {
					padding-left: 10px;
					font-size: 14px;
					font-weight: 500;
				}
			}
		}
	}

	.ykbox {
		.yktitle {
			// display: flex;
			justify-content: space-between;

			.rightnum {
				font-size: 13px;
			}
		}
	}

	.popup-box {
		.van-cell {
			padding: 0 !important;
			line-height: 50px;
		}
	}
</style>
